import React from "react";
import {Route, Routes} from "react-router-dom";
import PaiPointHome from "../pages/main/PaiPointIndex/home";

const PaiRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<PaiPointHome />} />
            <Route path="/index" element={<PaiPointHome />} />
        </Routes>
    )
}

export default PaiRoutes;